
import { countAd } from '@/http/api'
import {
  defineComponent,
  reactive,
  toRefs,
} from 'vue'
import { useStore } from 'vuex'
export default defineComponent({
  name: '',
  props: {
    imgUrl: {
      type: String,
    },
    h5AdLink: {
      type: String,
    },
    appAdLink: {
      type: String,
    },
    styleObj: {
      type: Object,
    },
  },
  setup(props: any) {
    const store = useStore()
    const data = reactive({
      browserEnv: store.state.browserEnv,
    })
    const methods = {
      jumpPage() {
        if (props.appAdLink || props.h5AdLink) {
          countAd(6311)
          if (data.browserEnv === 1) {
            window.location.href = props.appAdLink
          } else if (data.browserEnv === 2 || data.browserEnv === 3) {
            window.location.href = props.h5AdLink
          }
        }
      },
    }
    return {
      ...toRefs(data),
      ...methods,
    }
  },
})
